/**
 * IMPORTS
 */
import { toast } from "react-toastify";

const notifySuccess = (message: string) =>
  toast(message, {
    type: "success",
    position: "top-center",
  });

const notifyError = (message: string) =>
  toast(message, {
    type: "error",
    position: "top-center",
  });

const notifyAlert = (message: string) =>
  toast(message, {
    type: "warning",
    position: "top-center",
  });

export { notifyAlert, notifyError, notifySuccess };
